/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Golden Horn: presentation only; never set consent or replace Shopify's buttons. */
(function () {
  function compactBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.classList.contains('gh-cookie-compact')) return;
    var heading = banner.querySelector('h2');
    var paragraph = banner.querySelector('.shopify-pc__banner__body p');
    var privacyLink = paragraph && paragraph.querySelector('a');
    var preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!heading || !paragraph || !privacyLink || !preferences) return;
    if (/^en(?:-|$)/i.test(document.documentElement.lang)) {
      heading.textContent = 'Cookie choices';
      var link = privacyLink.cloneNode(true);
      link.textContent = 'Privacy policy';
      paragraph.replaceChildren(
        document.createTextNode('With your permission, we and our partners, including Shopify, use cookies to personalise your experience, show relevant ads and analyse traffic. '),
        link,
        document.createTextNode('.')
      );
      preferences.textContent = 'Preferences';
    }
    banner.classList.add('gh-cookie-compact');
  }
  compactBanner();
  new MutationObserver(compactBanner).observe(document.body, { childList: true, subtree: true });
})();

/* Golden Horn: place collection reviews at the bottom of the filter sidebar. */
(function () {
  if (!document.body.classList.contains('Template--collection')) return;
  function placeCollectionReviews() {
    var main = document.getElementById('MainContent');
    var aside = main && main.querySelector('.CollectionAside');
    if (!aside) return;
    document.querySelectorAll('[id^="trustpilot-widget-trustbox-"][id$="-wrapper"]').forEach(function (widget) {
      if (widget.closest('.CollectionAside') && aside.lastElementChild !== widget) aside.appendChild(widget);
    });
  }
  placeCollectionReviews();
  new MutationObserver(placeCollectionReviews).observe(document.getElementById('MainContent'), { childList: true, subtree: true });
})();
